import { SET_LOCALE, SAVE_LOCALE } from '@/store/mutation-types'
import i18n, { isValidLocale, getLocale } from '@/locale'

const state = {
  locale: getLocale()
}

const mutations = {
  [SET_LOCALE] (state, locale) {
    state.locale = isValidLocale(locale) ? locale : state.locale
    i18n.locale = state.locale
  },
  [SAVE_LOCALE] (state, locale) {
    state.locale = isValidLocale(locale) ? locale : state.locale
    i18n.locale = state.locale
    window.localStorage.setItem('locale', locale)
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/i18n.js